import { Outlet } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

import Login from '../../pages/Login';
import Header from '../molecules/Header';
import Sidebar from '../molecules/SideBar';

export const AuthTemplate = () => {
	const { isAuthenticated, isLoading, error } = useAuth();

	// Show loading state while checking authentication
	if (isLoading) {
		return <Login redirectHome={false} isLoading={isLoading} />;
	}

	// Show error state if authentication failed or user is not authenticated
	if (error || !isAuthenticated) {
		return <Login redirectHome={false} error={error} />;
	}

	return (
		<div className="flex h-screen w-screen bg-background">
			<Sidebar />
			<div className="flex h-full max-h-screen w-full flex-col overflow-auto bg-background px-4 py-3">
				<Header />
				<Outlet />
			</div>
		</div>
	);
};
